import React from 'react';
import { Transition } from '@headlessui/react';
import { Loader } from 'ui';

import CardContent from './CardContent';
import CardFooter from './CardFooter';
import CardHeader from './CardHeader';

type Props = {
  id?: string;
  basic?: boolean;
  loading?: boolean;
  flat?: boolean;
  children: React.ReactNode;
};

function Card({ id, basic, children, loading = false, flat = false }: Props) {
  const classArray = ['relative', 'bg-white', 'rounded-lg'];

  if (flat) {
    classArray.push('border', 'border-gray-200');
  } else {
    classArray.push('shadow');
  }

  if (basic) {
    classArray.push('card-basic'); // custom class
  }

  return (
    <div className={classArray.join(' ')} id={id}>
      <Transition
        className="absolute inset-0 z-20"
        show={loading}
        enter="transition ease-in duration-50"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition ease-out duration-50"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="absolute inset-0 z-20 flex items-center justify-center rounded-lg bg-white opacity-70">
          <Loader size="huge" />
        </div>
      </Transition>

      <div className="contents">{children}</div>
    </div>
  );
}

export default Object.assign(Card, { Content: CardContent, Header: CardHeader, Footer: CardFooter });
